module.exports = function(countryId) {
    countryId = String(countryId || '')
    return countryId.match(/(DK|GL|FO)/)
}
